import React, { useState } from 'react';
import { B } from '../constants';
import { users } from '../api';

export default function FollowButton({ userId, initialFollowing = false, size = 'md', onUpdate }) {
  const [following, setFollowing] = useState(initialFollowing);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      if (following) {
        await users.unfollow(userId);
        setFollowing(false);
      } else {
        await users.follow(userId);
        setFollowing(true);
      }
      onUpdate?.(following);
    } catch (err) {
      console.error('Follow error:', err);
    } finally {
      setLoading(false);
    }
  };

  const isSmall = size === 'sm';
  const isLarge = size === 'lg';
  
  const padding = isSmall ? '6px 12px' : isLarge ? '12px 24px' : '8px 16px';
  const fontSize = isSmall ? 11 : isLarge ? 14 : 12;

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        background: following ? 'transparent' : B.forest,
        color: following ? B.muted : 'white',
        border: following ? `1px solid ${B.sand}` : 'none',
        padding,
        borderRadius: 50,
        cursor: loading ? 'wait' : 'pointer',
        fontFamily: "'Montserrat',sans-serif",
        fontSize,
        fontWeight: 700,
        transition: 'all 0.2s',
        minWidth: isSmall ? 70 : isLarge ? 100 : 80,
      }}
    >
      {loading ? '...' : following ? 'Following' : 'Follow'}
    </button>
  );
}